import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUserLoggedIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M22 12c0 5.5-4.4 10-10 10S2 17.5 2 12C2 6.4 6.4 2 12 2s10 4.4 10 10m-10.1 8.6c.8 0 1.5 0 2.2-.3 1.1-.3 2-.7 2.9-1.4.7-.5 1.4-1.2 1.9-1.9v-.1c-.2-1-.4-1.9-1-2.8-.4-.7-1.1-1.2-1.9-1.3h-.3c-.8.8-1.8 1.3-2.9 1.5-.9.2-1.9 0-2.8-.2-.8-.3-1.5-.7-2-1.3h-.2c-.9.1-1.5.6-2 1.4S5 16 4.9 16.9v.2c.4.6.9 1.1 1.4 1.6 1.6 1.3 3.4 2 5.5 2Zm4.4-11.5c0-2.3-2-4.3-4.4-4.2-2.3 0-4.3 2-4.2 4.4 0 2.3 2 4.3 4.4 4.2 2.4 0 4.3-2 4.2-4.4" />
  </svg>
);
export default SvgUserLoggedIn;
